/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createReceipt} from '../api'

export const useMutationCreateReceipt = createReactQueryMutationHook('createReceipt', createReceipt)
